import { Clock, LogOut } from 'lucide-react';
import { useAuth } from '@/auth/AuthProvider';

/**
 * Slim, non-blocking top banner shown to users whose membership is pending.
 * The map stays visible behind it (read-only observer mode) — never a modal.
 */
export function PendingBanner(): React.JSX.Element {
  const { logout } = useAuth();

  return (
    <div className="fixed inset-x-0 top-0 z-[2000] flex h-9 items-center justify-center gap-2 border-b border-echo-yellow/30 bg-echo-yellow/10 px-4 text-xs text-echo-yellow backdrop-blur-sm">
      <Clock className="h-3.5 w-3.5 shrink-0" />
      <span className="font-medium tracking-wide">
        Membership pending approval — read-only observer
      </span>
      <button
        onClick={logout}
        className="ml-2 inline-flex items-center gap-1 rounded px-1.5 py-0.5 text-echo-yellow/80 transition-colors hover:bg-echo-yellow/15 hover:text-echo-yellow focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-echo-yellow/50"
      >
        <LogOut className="h-3 w-3" />
        Sign out
      </button>
    </div>
  );
}
